interface FeatureMarketingCopy {
  promotion?: string;
  comboHint?: string;
}

export const FEATURE_MARKETING: Record<string, FeatureMarketingCopy> = {
  combo: {
    promotion: "ЧЕРНАЯ ПЯТНИЦА ДО 15.11.2026",
  },
  commercial_offer_export: {
    comboHint: "В Комбо выгоднее",
  },
  template_access: {
    comboHint: "В Комбо выгоднее",
  },
  additional_employees: {
    comboHint: "Уже входит в Комбо",
  },
};

export const FEATURE_SUBSCRIPTION_NOTE = "Одна подписка работает на телефоне, планшете и компьютере без доплат.";
